import { ErrorContainer } from '../../../pages/UserSearch/UserSearch.styles';
import { StyledErrorIconContainer, StyledTypographyContainer } from '../Retry/Retry.styles';
import { Box, Button, Icon, Typography } from '@hiiretail/synergy-ui';
import { useHistory } from 'react-router-dom';
import { ServerNotRespondComponent } from './ServerError.types';

export const ServerError: ServerNotRespondComponent = ({
  error,
  backRoute,
}) => {
  const history = useHistory();
  const handleClick = () => history.push(backRoute as string);

  return error ? (
    <ErrorContainer
      container
      item
      flex='1 1 auto'
      alignItems='center'
      justifyContent='center'
      direction='column'
    >
      <StyledErrorIconContainer size='xlg' container item>
        <Icon.WarningRound color={() => '#F44336'} size='lg' />
      </StyledErrorIconContainer>

      <StyledTypographyContainer container direction='column' alignItems='center' size='xlg'>
        <Typography variant='header3' textAlign='center'>
          Server does not respond.
        </Typography>
        <Box mb={2}>
          <Typography textAlign='center'>
            Check your internet connection or try later!
          </Typography>
        </Box>
        {
          backRoute && (
            <Button type='button' onClick={handleClick}>
              Go back
            </Button>
          )
        }
      </StyledTypographyContainer>
    </ErrorContainer>
  ) : null;
};
